import * as React from 'react';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import UIDetailsBasis, { IProps as IUIDetailsBasisProps } from './UI.Details.Basis';
import { Field } from 'kts-scaffold-framework/utils/doc';
import moment from 'moment';
import { Row, Col, Table, Divider, Tooltip } from 'antd';
const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
    
}

/** Props接口 */
interface IProps extends IUIDetailsBasisProps, IReduxStatePart {
}

/** 详情产品1 */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIDetailsRoll extends UIDetailsBasis<IProps, ModulesState> {
    
    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    renderNItem = (leftData, rightData) => {
        return (
            <div className={`${css.itemBox} ${css.flexRow}  ${css.flexMBetween}`}>
                <div className={`${css.item} ${css.flexRow}  ${css.flexMStart}`}>
                    <div className={css.itemTitles}>
                        {
                            Array.from(leftData.keys()).map((key: any) => {
                                return (
                                    <div key={key.toString()} className={`${css.textR} ${css.itemText}`}>{key}</div>
                                );
                            })
                        }
                    </div>
                    <div className={css.itemValues}>
                        {
                            Array.from(leftData.values()).map((key: any) => {
                                return (
                                    <div key={key.toString()} className={`${css.itemText}`}>{key}</div>
                                );
                            })
                        }
                    </div>
                </div>
                <div className={`${css.item} ${css.flexRow}  ${css.flexMEnd}`}>
                    <div className={css.itemTitles}>
                        {
                            Array.from(rightData.keys()).map((key: any) => {
                                return (
                                    <div key={key.toString()} className={`${css.textR} ${css.itemText}`}>{key}</div>
                                );
                            })
                        }
                    </div>
                    <div className={css.itemValues}>
                        {
                            Array.from(rightData.values()).map((key: any) => {
                                return (
                                    <div key={key.toString()} className={`${css.textR} ${css.itemText}`}>{key}</div>
                                );
                            })
                        }
                    </div>
                </div>
            </div>
        );
    }
    render() {
        const columns = [
            {
              title: <span style={{fontWeight: 800}}>项目</span>,
              dataIndex: 'name',
              key: 'name'
            },
            {
              title: <span style={{fontWeight: 800}}>数量</span>,
              dataIndex: 'quantity',
              key: 'quantity',
            },
            {
              title: <span style={{fontWeight: 800}}>单价</span>,
              dataIndex: 'unitPrice',
              key: 'unitPrice',
            },
            {
              title: <span style={{fontWeight: 800}}>金额</span>,
              key: 'taxDetailAmount',
              dataIndex: 'taxDetailAmount',
            }
        ];
        const invoiceDetails = this.modulesState.invoiceDetails as any;
        return (
            <div className={css.newDetails}>
                {
                    this.renderNItem(new Map([
                        ['购买方', <span key={'购买方'} style={{fontWeight: 800}}>{invoiceDetails.buyerName}</span>],
                        ['纳税人识别号', invoiceDetails.buyerTaxId],
                        ['地址及电话', invoiceDetails.buyerAddressPhone],
                        ['开户行及账号', invoiceDetails.buyerBankAndId],
                    ]), new Map([
                        ['发票代码', invoiceDetails.invoiceCode],
                        ['发票号码', invoiceDetails.invoiceNumber],
                        ['开票日期', invoiceDetails.invoiceDate ? moment.unix(invoiceDetails.invoiceDate / 1000).format('YYYY-MM-DD') : ""],
                        ['校验码', invoiceDetails.invoiceParityCode],
                    ]))
                }
                <Table 
                    columns={columns} 
                    dataSource={invoiceDetails.saleItemList || []}
                    pagination={false}
                />

                {
                    this.renderNItem(new Map(), new Map([
                        ['总金额(大写)', invoiceDetails.amount ? <span key={'总金额(大写)'} style={{fontWeight: 800}}>{Field.toStringChinese(invoiceDetails.amount)}</span> : ''],
                        ['合计金额(小写)', invoiceDetails.amount? <span key={'合计金额(小写)'} style={{fontWeight: 800}}>{`¥${Field.formatMoney(invoiceDetails.amount, 2)}`}</span>: ''],
                    ]))
                }
                <Divider/>
                {
                    this.renderNItem(new Map([
                        ['销售方', <span key={'销售方'} style={{fontWeight: 800}}>{invoiceDetails.supplierName}</span>],
                        ['纳税人识别号', invoiceDetails.supplierTaxId],
                        ['地址及电话', invoiceDetails.supplierAddressPhone],
                        ['开户行及账号', invoiceDetails.supplierBankAndId],
                    ]), new Map([
                        ['备注', invoiceDetails.remark],
                    ]))
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/display/part/InvoiceDetails/UI.Details.roll.tsx